import { useMemo } from "react";

import { resolveNodeLinkagesPreventingMoveToSlotCreateFromState } from "@skilitics/nautilus-core-designer-data";

import { getRuntimeManifestCreate } from "../nodes/getRuntimeManifest.ts";
import { useGetManifest } from "./selectorWrappers/index.ts";
import { useNodeDesignsState } from "./useNodeDesignsState.ts";

export const useResolveNodeLinkagesBlockingMoveToSlot = () => {
  const getManifest = useGetManifest();
  // TODO: state shouldn't be used here, create selectors at a lower level.
  const state = useNodeDesignsState();

  const getRuntimeManifest = useMemo(() => getRuntimeManifestCreate({ getManifest }), [getManifest]);

  return useMemo(
    () => resolveNodeLinkagesPreventingMoveToSlotCreateFromState(state, getRuntimeManifest),
    [getRuntimeManifest, state],
  );
};

export type CanImportResult =
  | true
  | ({ value: false } & (
      | { message: string }
      | ReturnType<ReturnType<typeof useResolveNodeLinkagesBlockingMoveToSlot>>
    ));
